// Helper function to build URLs based on language
function buildUrl(path, lang) {
  return lang === 'en' ? path : `/${lang}${path}`;
}

// Store the current collection handle and language in localStorage when visiting a collection page
if (window.location.pathname.includes('/collections/')) {
  const pathParts = window.location.pathname.split('/');
  const collectionsIndex = pathParts.indexOf('collections');
  
  if (collectionsIndex !== -1 && pathParts[collectionsIndex + 1]) {
    const collectionHandle = pathParts[collectionsIndex + 1];
    const currentLang = document.documentElement.lang;
    
    // Build collection URL using the helper function
    const collectionUrl = buildUrl(`/collections/${collectionHandle}`, currentLang);
    
    localStorage.setItem('lastVisitedCollection', collectionHandle);
    localStorage.setItem('lastVisitedLanguage', currentLang);
    localStorage.setItem('lastVisitedCollectionUrl', collectionUrl);
  }
}  